import React from 'react';

const NewsIcon = () => (
    <div className='NewsIcon DesktopIcon'>
        <img
            // src='/images/NewsIcon.png'
            src='/images/Finalized/NewsIcon.png'
            alt='News'
            draggable={false}
            onDragStart={(e) => e.preventDefault()}
        />
        <span>News</span>
    </div>
);

export default NewsIcon;
